'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _ = require('../');

var _SolutionsList = require('./SolutionsList.css');

var _SolutionsList2 = _interopRequireDefault(_SolutionsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SolutionsList = (_dec = (0, _reactCssModules2.default)(_SolutionsList2.default, { allowMultiple: true }), _dec(_class = function (_Component) {
  (0, _inherits3.default)(SolutionsList, _Component);

  function SolutionsList() {
    (0, _classCallCheck3.default)(this, SolutionsList);
    return (0, _possibleConstructorReturn3.default)(this, (SolutionsList.__proto__ || (0, _getPrototypeOf2.default)(SolutionsList)).apply(this, arguments));
  }

  (0, _createClass3.default)(SolutionsList, [{
    key: 'render',
    value: function render() {
      var icon1 = require('../../../static/images/123-1.png');
      var icon2 = require('../../../static/images/123-2.png');
      var titles = {
        0: 'Employees need access to sustainable investing',
        1: 'Sustainability should be the standard'
      };
      var descriptions = {
        0: 'If a retirement plan doesn’t offer sustainable options, employees are being forced to assume the financial risks of unsustainable investing, often without understanding the long-term impacts. ',
        1: 'Making the default investment option sustainable is the best way to protect everyone from the financial risks of unsustainable investments.'
      };
      return _react2.default.createElement(
        'nav',
        { styleName: 'solutions-list' },
        [[_config2.default.routes.solutionOfferSustainability, icon1], [_config2.default.routes.solutionDefaultSustainability, icon2]].map(function (e, i) {
          var _e = (0, _slicedToArray3.default)(e, 2),
              url = _e[0],
              icon = _e[1];

          var title = titles[i] || 'Lorem';
          var description = descriptions[i] || 'Lorem';
          return _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'button',
              {
                styleName: 'data-link',
                key: 'data-link-' + i
              },
              _react2.default.createElement(
                _.Link,
                {
                  to: url,
                  title: title
                },
                _react2.default.createElement(
                  'div',
                  { styleName: 'data-link-in' },
                  _react2.default.createElement('img', {
                    src: icon,
                    alt: title
                  }),
                  _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                      'h2',
                      null,
                      title
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      description
                    ),
                    _react2.default.createElement(
                      'p',
                      null,
                      'Learn more',
                      _react2.default.createElement(_.LinkIcon, null)
                    )
                  )
                )
              )
            ),
            _react2.default.createElement('hr', null)
          );
        })
      );
    }
  }]);
  return SolutionsList;
}(_react.Component)) || _class);
exports.default = SolutionsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/SolutionsList/SolutionsList.js
// module id = 1442
// module chunks = 0